import React, { Fragment, useState, useEffect } from "react";
import dayjs from "dayjs";
import Spinner from "../plugins/Spinner";
import Pagination from "../plugins/Pagination";
import usePage from "../../hooks/usePage";
import useAPI from "../../hooks/useAPI";
import Header from "../layout/Header";
import { BsSearch, BsCheckCircle, BsExclamationCircle, BsXCircle, BsQuestionCircle, BsWhatsapp } from "react-icons/bs";
import { FaEye } from "react-icons/fa";
import { FaEllipsisVertical } from "react-icons/fa6";
import { toast } from "react-toastify";
import { sendToast } from "../plugins/toastAll";
import { Toaster } from "react-hot-toast";

const LinesModule = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);
  const [validation, setValidation] = useState(false);
  const [lines, setLines] = useState([]);
  const [linesTable, setLinesTable] = useState([]);
  const [isDark, setIsDark] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);
  const [search, setSearch] = useState("");

  const { page, setPage, byPage, resetPage } = usePage();
  const { urlAPI_2, fetchWithAuth } = useAPI();

  useEffect(() => {
    setValidation(true);

    const dark = localStorage.getItem("IS_DARK");
    setIsDark(dark);

    getCompanie();

    const handleMetaMessage = (event) => {
      try {
        if (!event.origin.includes("facebook.com")) return;

        const data =
          typeof event.data === "string"
            ? JSON.parse(event.data)
            : event.data;

        console.log("META EVENT:", data);

        if (data.type === "WA_EMBEDDED_SIGNUP" && data.event === "FINISH") {
          const metaWabaData = {
            waba_id: data.data?.waba_id || "",
            phone_number_id: data.data?.phone_number_id || "",
            business_id: data.data?.business_id || "",
          };

          console.log("META WABA DATA:", metaWabaData);

          localStorage.setItem("META_WABA_DATA", JSON.stringify(metaWabaData));
        }
      } catch (e) {
        console.log("Meta message ignored:", e);
      }
    };

    window.addEventListener("message", handleMetaMessage);

    const loadFacebookSDK = () => {
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: "900570192212204",
          autoLogAppEvents: true,
          xfbml: true,
          version: "v23.0",
        });
      };

      (function (d, s, id) {
        let js;
        const fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;

        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        js.async = true;
        js.defer = true;
        js.crossOrigin = "anonymous";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    };

    loadFacebookSDK();

    const fetchData = async () => {
      try {
        await Promise.all([checkRegistered()]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    return () => {
      window.removeEventListener("message", handleMetaMessage);
    };
  }, []);

  const getCompanie = async () => {
    const resultIdCompany = localStorage.getItem("ID_COMPANY");

    try {
      setIsLoading(true);

      const url = urlAPI_2 + "companies/" + resultIdCompany;
      const options = { method: "GET", mode: "cors" };
      const response = await fetchWithAuth(url, options);
      const result = await response.json();

      console.log("Response of the API GETCOMPANY----------======>> ", result);

      if (result.code === 0) {
        sendToast(result);
      } else if (!result.data) {
        setValidation(true);
      } else {
        const {
          displayPhoneNumber,
          qualityRating,
          verifiedName,
          currentLimit,
          created,
          isDark,
          phoneNumberType,
        } = result.data[0];

        setIsDark(isDark);

        if (displayPhoneNumber) {
          setValidation(false);

          const i = {
            name: verifiedName,
            line: displayPhoneNumber,
            quality: qualityRating,
            currentLimit,
            created,
            phoneNumberType,
          };

          setLines([i]);
          setLinesTable([i]);
        } else {
          setValidation(true);
        }
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("---------->", error);
    }
  };

  const checkRegistered = async () => {
    try {
      const url = urlAPI_2 + "checkCompanyPhoneNumberRegister";
      const options = { method: "GET", mode: "cors" };
      const response = await fetchWithAuth(url, options);
      const result = await response.json();

      setIsRegistered(!!result.status);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getCompanyData = async () => {
    try {
      const url = urlAPI_2 + "checkCompanyPhoneNumberRegister";
      const options = { method: "GET", mode: "cors" };
      const response = await fetchWithAuth(url, options);
      const result = await response.json();

      setIsRegistered(!!result.status);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const launchWhatsAppSignup = () => {
    localStorage.removeItem("META_WABA_DATA");

    window.FB.login(
      (response) => {
        console.log("response de login de empresas: ", response);

        if (response.authResponse) {
          console.log("📣 FB.login raw response:", JSON.parse(JSON.stringify(response)));
          console.log("✅ response.authResponse:", JSON.parse(JSON.stringify(response.authResponse)));
          console.log("🔐 Authorization Code:", response.authResponse.code);

          const code = response.authResponse.code;

          const getAccessToken = async () => {
            try {
              setIsLoading(true);
              setIsRegistering(true);

              const metaWabaData = JSON.parse(
                localStorage.getItem("META_WABA_DATA") || "{}"
              );

              const url = urlAPI_2 + "getAccessToken";

              const options = {
                method: "POST",
                mode: "cors",
                body: JSON.stringify({
                  code,
                  waba_id: metaWabaData.waba_id || "",
                  phone_number_id: metaWabaData.phone_number_id || "",
                  business_id: metaWabaData.business_id || "",
                }),
              };

              console.log("Sending getAccessToken body:", JSON.parse(options.body));

              const response = await fetchWithAuth(url, options);
              const result = await response.json();

              setIsLoading(false);
              setIsRegistering(false);

              console.log(result);
              console.log("Access Token:", result.accessToken);

              if (result.result.error) {
                sendToast({
                  type: "error",
                  message: "Se produjo un error durante el proceso de registro. Por favor contactese con el administrador.",
                });
              } else {
                await getCompanyData();

                sendToast({
                  type: "success",
                  message: `El registro se ha realizado de forma exitosa. Puedes escribirle <a id="send-test" href="${result.result.wame}" target="_blank">aquí</a>`,
                  time: false,
                });
              }
            } catch (error) {
              setIsLoading(false);
              setIsRegistering(false);
              console.error("Error al obtener el Access Token:", error);
            }
          };

          getAccessToken();
        } else {
          console.log("User cancelled login or did not fully authorize.");
          sendToast({
            type: "info",
            message: "El proceso de registro insertado fue cancelado.",
          });
        }
      },
      {
        config_id: "609094528303718",
        response_type: "code",
        override_default_response_type: true,
        scope:
          "public_profile,email,business_management,whatsapp_business_management,whatsapp_business_messaging,catalog_management",
        return_scopes: true,
        extras: {
          setup: {},
          featureType: "whatsapp_business_app_onboarding",
          sessionInfoVersion: "3",
        },
      }
    );
  };

  const getQualityRatingDisplay = (qualityRating) => {
    switch (qualityRating) {
      case "GREEN":
        return { text: "Alta", color: "#28a745", icon: <BsCheckCircle /> };
      case "YELLOW":
        return { text: "Media", color: "#ffc107", icon: <BsExclamationCircle /> };
      case "RED":
        return { text: "Baja", color: "#dc3545", icon: <BsXCircle /> };
      default:
        return { text: "Desconocida", color: "#6c757d", icon: <BsQuestionCircle /> };
    }
  };

  const getCurrentLimitDisplay = (currentLimit) => {
    switch (currentLimit) {
      case "TIER_50":
        return { text: "50" };
      case "TIER_250":
        return { text: "250" };
      case "TIER_1K":
        return { text: "1000" };
      case "TIER_10K":
        return { text: "10000" };
      case "TIER_100K":
        return { text: "100000" };
      case "TIER_UNLIMITED":
        return { text: "Ilimitado" };
      default:
        return { text: "Desconocido" };
    }
  };

  const searchQuery = (searchTerm) => {
    const searchResults = linesTable.filter((element) => {
      return (
        element.name.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
        element.line.toString().toLowerCase().includes(searchTerm.toLowerCase())
      );
    });

    console.log("lineas filtradas: ", searchResults);

    setLines(searchResults);
    setValidation(searchResults.length === 0);
  };

  const disconnectLine = async (line) => {
    try {
      const url = urlAPI_2 + "disconnectLine/";
      const options = {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(line),
      };

      const response = await fetchWithAuth(url, options);
      const result = await response.json();

      await refresh();

      if (response.status === 200 || result.code === 0) {
        sendToast({
          type: "success",
          message: result.message || "Línea desvinculada correctamente",
          time: false,
        });
      } else {
        sendToast({
          type: "error",
          message: result.message || "Ocurrió un error al desvincular",
          time: false,
        });
      }
    } catch (error) {
      console.error("disconnectLine error:", error);
      sendToast({
        type: "error",
        message: "Error inesperado al intentar desvincular la línea",
        time: false,
      });
    }
  };

  const refresh = async () => {
    await getCompanie();
    await checkRegistered();
  };

  const Modal = ({ line, closeToast }) => {
    return (
      <div className="grid grid-cols-[1fr_1px_80px] w-full">
        <div className="flex flex-col p-4" style={{ width: "30em" }}>
          <div className="text-center">
            <h3 className="text-zinc-800 text-sm font-semibold">{line.name}</h3>
            <p className="text-zinc-800 text-sm font-semibold text-center">{line.line}</p>
          </div>

          <div className="d-flex justify-content-between align-items-center mt-2">
            <label>Límite díario:</label>
            <p className="text-sm">{getCurrentLimitDisplay(line.currentLimit).text}</p>
          </div>

          <div className="d-flex justify-content-between align-items-center mt-2">
            <label>Nivel de calidad:</label>
            {(() => {
              const { text, color, icon } = getQualityRatingDisplay(line.quality);

              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: color,
                    color: "#fff",
                    borderRadius: "20px",
                    padding: "0px 10px",
                    fontWeight: "bold",
                    width: "auto",
                    height: "2rem",
                  }}
                >
                  <span style={{ marginRight: "10px", fontSize: "16px", marginTop: "4px" }}>
                    {icon}
                  </span>
                  {text}
                </div>
              );
            })()}
          </div>

          <div className="d-flex justify-content-between align-items-center mt-2">
            <label>Fecha de conexión:</label>
            <p className="text-sm">{dayjs(line.created).locale("es").format("DD MMMM YYYY")}</p>
          </div>
        </div>

        <div className="bg-zinc-900/20 h-full" />

        <div className="d-flex justify-content-evenly mt-1 pt-1">
          <a href="javascript:;" className="btn btn-lg btn-default mr-1" onClick={() => closeToast()}>
            Cerrar
          </a>
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      {isLoading && (
        <div className="loader-overlay">
          <div className="loader-content">
            {isRegistering && <p>Por favor aguarde, estamos conectando su línea...</p>}
            <Spinner />
          </div>
        </div>
      )}

      <div className="m-auto container-fluid p-0 h-100">
        <div className="col-xs-9 heading">
          <div className="mt-2">
            <h1>Líneas</h1>

            {!isRegistered && (
              <input
                type="button"
                className="btn btn-default mr-2"
                value="Agregar nueva"
                onClick={() => launchWhatsAppSignup()}
              />
            )}

            <input
              type="button"
              className="btn btn-default mr-2"
              value="Actualizar"
              onClick={refresh}
            />
          </div>

          <Header />
        </div>

        <header>
          <div style={{ float: "right" }}>
            <form className="form-inline">
              <div className="su-control my-1">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Búsqueda"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    searchQuery(e.target.value);
                    resetPage();
                  }}
                />

                <button
                  className="btn btn-info"
                  type="button"
                  id="buttonSearchProductBack"
                  style={{ height: "34px" }}
                >
                  <BsSearch />
                </button>
              </div>
            </form>
          </div>
        </header>

        <div
          className="container-fluid mt-3 px-0"
          style={{ height: "75%", overflowY: "auto", overflowX: "none" }}
        >
          <table className="table table-striped">
            <thead style={{ position: "sticky", top: "-1px", zIndex: "99" }}>
              <tr>
                <th>Acciones</th>
                <th>Nombre verificado</th>
                <th>Número de teléfono</th>
                <th>Nivel de calidad</th>
                <th>Límite de mensajes</th>
                <th>Tipo de conexión</th>
                <th>Fecha de conexión</th>
              </tr>
            </thead>

            <tbody>
              {!validation &&
                lines.length > 0 &&
                lines
                  .slice((page - 1) * byPage, (page - 1) * byPage + byPage)
                  .map((line, k) => {
                    return (
                      <tr key={k}>
                        <td>
                          <div className="d-flex align-items-center justify-content-center">
                            <div className="dropdown">
                              <button
                                className="bg-transparent border-0"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                <FaEllipsisVertical className="text-success f-24 pointer" />
                              </button>

                              <div className="dropdown-menu p-2" aria-labelledby="dropdownMenuButton">
                                <button
                                  className="text-primary border-0 bg-transparent d-block pointer mt-2"
                                  onClick={() => {
                                    toast.dismiss();
                                    toast(<Modal line={line} />, {
                                      position: "top-center",
                                      autoClose: false,
                                      hideProgressBar: false,
                                      closeOnClick: false,
                                      pauseOnHover: true,
                                      draggable: false,
                                      progress: undefined,
                                      theme: JSON.parse(isDark) ? "dark" : "light",
                                      className: "custom-toast-container",
                                      bodyClassName: "custom-toast-body",
                                    });
                                  }}
                                >
                                  <FaEye style={{ fontSize: "18px", color: "#ff9317" }} />
                                  <span className="text-dark ml-2 f-14">Ver</span>
                                </button>

                                <button
                                  className="text-danger border-0 bg-transparent d-block pointer mt-2"
                                  onClick={() => disconnectLine(line)}
                                >
                                  <BsXCircle style={{ fontSize: "18px", color: "#dc3545" }} />
                                  <span className="text-dark ml-2 f-14">Desvincular</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </td>

                        <td>
                          <label>
                            {line.name.length >= 35 ? line.name.substr(0, 35) + "..." : line.name}
                          </label>
                        </td>

                        <td>{line.line}</td>

                        <td style={{ textAlign: "-webkit-center" }}>
                          {(() => {
                            const { text, color, icon } = getQualityRatingDisplay(line.quality);

                            return (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: color,
                                  color: "#fff",
                                  borderRadius: "20px",
                                  fontWeight: "bold",
                                  width: "100%",
                                  height: "2.5rem",
                                }}
                              >
                                <span style={{ marginRight: "10px", fontSize: "16px", marginTop: "4px" }}>
                                  {icon}
                                </span>
                                {text}
                              </div>
                            );
                          })()}
                        </td>

                        <td>
                          <label>{getCurrentLimitDisplay(line.currentLimit).text}</label>
                        </td>

                        <td>{line.phoneNumberType}</td>

                        <td>{dayjs(line.created).locale("es").format("DD MMMM YYYY")}</td>
                      </tr>
                    );
                  })}
            </tbody>
          </table>

          {validation && (
            <div className="text-center mt-3">
              <div className="empty">
                <BsWhatsapp className="mr-2 ml-0 my-0" style={{ fontSize: "55px" }} />
                <h1>No tienes líneas conectadas</h1>

                <input
                  type="button"
                  className="btn btn-default"
                  value="Agregar nueva"
                  onClick={() => launchWhatsAppSignup()}
                />
              </div>
            </div>
          )}
        </div>

        <footer>
          <div className="row">
            <div className="col-md-8"></div>

            <div className="col-md-4">
              <Pagination totalData={lines.length} byPage={byPage} setPage={setPage} />
            </div>
          </div>
        </footer>
      </div>

      <Toaster />
    </Fragment>
  );
};

export default LinesModule;